export default {
    computed: {
        // Must mirror components/category/breadcrumbs.vue exactly — Google
        // ignores BreadcrumbList markup whose names and URLs do not match the
        // visible trail.
        breadcrumbsJsonldScript() {
            const baseUrl = `https://${this.$config.website.domain}`;

            const breadcrumbs = this.breadcrumbs || [];
            const name = this.name || this.product?.name || "";

            if (!name) return null;

            const schema = {
                "@context": "https://schema.org",
                "@type": "BreadcrumbList",
                itemListElement: [
                    {
                        "@type": "ListItem",
                        position: 1,
                        name: "Home",
                        item: `${baseUrl}/`,
                    },
                    {
                        // The visible crumb reads "Wellness Products", not "Catalog".
                        "@type": "ListItem",
                        position: 2,
                        name: "Wellness Products",
                        item: `${baseUrl}/catalog`,
                    },
                    ...breadcrumbs.map((crumb, i) => ({
                        "@type": "ListItem",
                        position: i + 3,
                        name: crumb.name,
                        // getCategoryLink is what the visible crumb links to —
                        // it falls back to /catalog/{treeId} when a category
                        // has no slug, which `/${crumb.slug}` got wrong.
                        item: `${baseUrl}${this.getCategoryLink(crumb)}`,
                    })),
                    {
                        // Last item carries name only: it is the current page,
                        // so per Google's spec it takes no `item`.
                        "@type": "ListItem",
                        position: breadcrumbs.length + 3,
                        name,
                    },
                ],
            };

            return {
                hid: "breadcrumbs-jsonld",
                type: "application/ld+json",
                innerHTML: JSON.stringify(schema),
            };
        },
    },
};
